export default __webpack_public_path__ + "static/media/saraburi_facebook_btn.d6012d92.webp";